const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhgEmissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgba(16, 163, 127, 1)",
      fillOpacity: 1
    },
    d: "M 13.277344 11.945312 C 13.917969 12.765625 14.46875 13.445312 14.765625 14.226562 C 15.058594 14.992188 15.175781 15.339844 14.515625 14.550781 C 13.898438 13.8125 13.324219 13.097656 12.484375 12.417969 C 12.421875 12.429688 12.359375 12.441406 12.292969 12.457031 C 4.683594 13.90625 -0.863281 10.621094 0.109375 0.00390625 C 5.972656 1.949219 14.277344 1.160156 13.417969 11.136719 C 13.386719 11.507812 13.359375 11.761719 13.277344 11.945312 Z M 11.234375 10.347656 C 9.320312 6.394531 4.40625 5.039062 1.96875 2.335938 C 4.613281 7.289062 6.058594 7.070312 11.234375 10.347656 Z M 11.234375 10.347656 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhgEmissions);
export default __webpack_public_path__ + "static/media/ghgEmissions.e5e9aa3bf99a62ea3341780698bfffb3.svg";
export { ForwardRef as ReactComponent };